export const courtesyClientInfoEsLocale = {
  'checkout.courtesyClientInfo.title': 'Información del cliente',
  'checkout.courtesyClientInfo.to': 'Dirigidas a:',
  'checkout.courtesyClientInfo.name': 'Nombre',
  'checkout.courtesyClientInfo.lastName': 'Apellido',
  'checkout.courtesyClientInfo.email': 'Correo electrónico',
  'checkout.courtesyClientInfo.confirmEmail': 'Confirmar correo electrónico',
  'checkout.courtesyClientInfo.entityName':
    'Nombre de la institución/empresa/patrocinador',
  'checkout.courtesyClientInfo.type': 'Tipo de cortesías',
  'checkout.courtesyClientInfo.sendToPrint':
    'Enviar a impresor de taquilla o punto de venta',

  'checkout.courtesyClientInfo.nameError': 'Ingresa el nombre',
  'checkout.courtesyClientInfo.lastNameError': 'Ingresa el apellido',
  'checkout.courtesyClientInfo.emailError': 'Ingresa el correo electrónico',
  'checkout.courtesyClientInfo.emailMatchError': 'Los correos no coinciden',
  'checkout.courtesyClientInfo.entityNameError':
    'Ingresa el nombre de la institución/empresa/patrocinador',
  'checkout.courtesyClientInfo.typeError': 'Selecciona el tipo de cortesía',

  'checkout.courtesyClientInfo.select': 'Seleccione una opción',
  'checkout.courtesyClientInfo.printed': 'Físicas (impresas)',
  'checkout.courtesyClientInfo.digital': 'Electrónicas',
  'checkout.courtesyClientInfo.blocked': 'Bloqueo',

  'checkout.courtesyClientInfo.continue': 'Continuar',
  'checkout.courtesyClientInfo.back': 'Regresar',

  'checkout.courtesyClientInfo.generate': 'Generar cortesía',
  'checkout.courtesyClientInfo.success': 'Cortesía generada con éxito',
  'checkout.courtesyClientInfo.error': 'Error al generar la cortesía',
  'checkout.courtesyClientInfo.procesing': 'Generando cortesía...',

  'checkout.courtesyClientInfo.great': '¡Excelentes noticias!',
  'checkout.courtesyClientInfo.purchase':
    'Tu compra el día de hoy es completamente',
  'checkout.courtesyClientInfo.free': 'gratis',
} as const;

export const courtesyClientInfoEnLocale = {
  'checkout.courtesyClientInfo.title': 'Client information',
  'checkout.courtesyClientInfo.to': 'To:',
  'checkout.courtesyClientInfo.name': 'Name',
  'checkout.courtesyClientInfo.lastName': 'Last name',
  'checkout.courtesyClientInfo.email': 'Email',
  'checkout.courtesyClientInfo.confirmEmail': 'Confirm email',
  'checkout.courtesyClientInfo.entityName': 'Institution/company/sponsor name',
  'checkout.courtesyClientInfo.type': 'Courtesy type',
  'checkout.courtesyClientInfo.sendToPrint': 'Send to ticket printer or POS',

  'checkout.courtesyClientInfo.nameError': 'Enter the name',
  'checkout.courtesyClientInfo.lastNameError': 'Enter the last name',
  'checkout.courtesyClientInfo.emailError': 'Enter the email',
  'checkout.courtesyClientInfo.emailMatchError': 'Emails do not match',
  'checkout.courtesyClientInfo.entityNameError':
    'Enter the institution/company/sponsor name',
  'checkout.courtesyClientInfo.typeError': 'Select the courtesy type',

  'checkout.courtesyClientInfo.select': 'Select an option',
  'checkout.courtesyClientInfo.printed': 'Physical (printed)',
  'checkout.courtesyClientInfo.digital': 'Digital',
  'checkout.courtesyClientInfo.blocked': 'Blocked',

  'checkout.courtesyClientInfo.continue': 'Continue',
  'checkout.courtesyClientInfo.back': 'Back',

  'checkout.courtesyClientInfo.generate': 'Generate courtesy',
  'checkout.courtesyClientInfo.success': 'Courtesy generated successfully',
  'checkout.courtesyClientInfo.error': 'Error generating the courtesy',
  'checkout.courtesyClientInfo.procesing': 'Generating courtesy...',

  'checkout.courtesyClientInfo.great': 'Great News!',
  'checkout.courtesyClientInfo.purchase': 'Your purchase today is completely',
  'checkout.courtesyClientInfo.free': 'free',
} as const;
